import { load } from "../entity-provider";
import { handleServerError } from "../../lib/providers/auth-provider";
import {
  answerOptionsDeserialize,
  questionnarieDeserialize
} from "../../utils/JSONAPI";
import { addPage } from "../../lib/providers/pagination-provider/actions";

const qs = require("qs");

export function getAnswerOptions(page, paginationKey, componentState = {}) {
  return async (dispatch, getState, server) => {
    const state = getState();
    const language = state.global.language.locale;

    const parameters = {
      page,
      search: componentState.search,
      searchId: componentState.searchId,
      filter: JSON.stringify(componentState.filter),
      sort: componentState.sort,
      language
    };

    await dispatch(
      load("answer_option", async () => {
        const response = await server.fetch(
          `/answerOption/?${qs.stringify(parameters)}`
        );

        const responseJson = await response.json();

        if (response.ok) {
          const res = await answerOptionsDeserialize(responseJson);
          if (paginationKey)
            await dispatch(
              addPage(
                paginationKey,
                responseJson.data.map(d => d.id),
                responseJson.meta
              )
            );

          return res;
        } else {
          await dispatch(handleServerError(server, responseJson));
          throw new Error(responseJson);
        }
      })
    );
  };
}

export function createAnswer(body, page, paginationKey, state) {
  return async (dispatch, getState, server) => {
    const options = {
      method: "PUT",
      body: body
    };

    await dispatch(
      load("answer_option", async () => {
        const response = await server.fetch(`/answerOption/`, options);
        const responseJson = await response.json();
        if (response.ok) {
          dispatch(getAnswerOptions(page, paginationKey, state));
        } else {
          await dispatch(handleServerError(server, responseJson));
          throw new Error(responseJson);
        }
      })
    );
  };
}

export function disableAnswer(answerId, page, paginationKey, state) {
  return async (dispatch, getState, server) => {
    const options = {
      method: "POST"
    };

    await dispatch(
      load("answer_option", async () => {
        const response = await server.fetch(
          `/answerOption/${answerId}/disable`,
          options
        );

        const responseJson = await response.json();

        if (response.ok) {
          dispatch(getAnswerOptions(page, paginationKey, state));
        } else {
          await dispatch(handleServerError(server, responseJson));
          throw new Error(responseJson);
        }
      })
    );
  };
}

export function deleteAnswer(answerId, page, paginationKey, state) {
  return async (dispatch, getState, server) => {
    const options = {
      method: "DELETE"
    };

    await dispatch(
      load("answer_option", async () => {
        const response = await server.fetch(
          `/answerOption/${answerId}/`,
          options
        );

        const responseJson = await response.json();

        if (response.ok) {
          dispatch(getAnswerOptions(page, paginationKey, state));
        } else {
          await dispatch(handleServerError(server, responseJson));
          throw new Error(responseJson);
        }
      })
    );
  };
}

export function enableAnswer(answerId, page, paginationKey, state) {
  return async (dispatch, getState, server) => {
    const options = {
      method: "POST"
    };

    await dispatch(
      load("answer_option", async () => {
        const response = await server.fetch(
          `/answerOption/${answerId}/enable`,
          options
        );

        const responseJson = await response.json();

        if (response.ok) {
          dispatch(getAnswerOptions(page, paginationKey, state));
        } else {
          await dispatch(handleServerError(server, responseJson));
          throw new Error(responseJson);
        }
      })
    );
  };
}

export function updateAnswer(answerId, body, page, paginationKey, state) {
  return async (dispatch, getState, server) => {
    await dispatch(
      load("answer_option", async () => {
        const options = {
          method: "PATCH",
          body: body
        };

        const response = await server.fetch(
          `/answerOption/${answerId}`,
          options
        );

        const responseJson = await response.json();
        if (response.ok) {
          dispatch(getAnswerOptions(page, paginationKey, state));
        } else {
          await dispatch(handleServerError(server, responseJson));
          throw new Error(responseJson);
        }
      })
    );
  };
}

export function addAnswerOptionValue(
  questionnaire_id,
  questionnaire_category_id,
  categoryQuestionId,
  value,
  answer_option_id,
  questionnaireId
) {
  return async (dispatch, getState, server) => {
    const options = {
      method: "PATCH",
      body: { value }
    };
    await dispatch(
      load(
        "questionnaire_category_question_answer_option_alg_value",
        async () => {
          const response = await server.fetch(
            `/questionnaire/${questionnaire_id}/questionnaireCategory/${questionnaire_category_id}/categoryQuestion/${categoryQuestionId}/answer/${answer_option_id}`,
            options
          );
          const responseJson = await response.json();

          if (response.ok) {
            return await questionnarieDeserialize(responseJson);
          } else {
            await dispatch(handleServerError(server, responseJson));
            throw new Error(responseJson);
          }
        }
      )
    );
  };
}

export function sortAnswerOptions(question_id, answer_option_id, index) {
  return async (dispatch, getState, server) => {
    await dispatch(
      load("question_answer_option", async () => {
        const options = {
          method: "PATCH",
          body: { index: index }
        };

        const response = await server.fetch(
          `/question/${question_id}/answerOption/${answer_option_id}`,
          options
        );

        const responseJson = await response.json();

        if (response.ok) {
          return await answerOptionsDeserialize(responseJson);
        } else {
          await dispatch(handleServerError(server, responseJson));
          throw new Error(responseJson);
        }
      })
    );
  };
}
